import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { WeekdayMinimumStayRuleItem } from '../../../common/types/rates.types';
import WeekdayMinimumStayRestrictionsForm from './WeekdayMinimumStayRestrictionsForm';
import {
  addWeekdayMinimumStayRestriction,
  getWeekdayMinimumStayRulesDataAsync,
  removeWeekdayMinimumStayRestriction,
  selectWeekdayMinimumStayRuleItemsData,
  selectWeekdayMinimumStayRuleItemsDataLoadingStatus,
  updateSeasonRateWeekdayMinimumStayRulesDataAsync,
  updateWeekdayMinimumStayRestriction,
  updateWeekdayMinimumStayRuleItemsData,
} from '../seasonRateWeekdayRulesSlice';

function SeasonRateWeekdayMinimumStayRestrictions({
  seasonRateId,
  hasWriteAccess,
}: {
  seasonRateId: string;
  hasWriteAccess: boolean;
}) {
  const dispatch = useAppDispatch();
  const weekdayMinimumStayRuleItemsData = useAppSelector(
    selectWeekdayMinimumStayRuleItemsData,
  );
  const weekdayMinimumStayRuleItemsDataStatus = useAppSelector(
    selectWeekdayMinimumStayRuleItemsDataLoadingStatus,
  );

  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    dispatch(getWeekdayMinimumStayRulesDataAsync(seasonRateId));
  }, [seasonRateId, dispatch]);

  const handleWeekdayMinimumStayRuleChange = (event, weekdayInt) => {
    const { value } = event.target;
    if (value && value > 0) {
      const existingRule =
        weekdayMinimumStayRuleItemsData?.weekdayMinimumDurations?.find(
          rule => rule?.weekday === weekdayInt,
        );

      if (existingRule) {
        const newData = { ...existingRule };
        newData.minimumDurationForCheckIn = value;
        dispatch(updateWeekdayMinimumStayRestriction(newData));
      } else {
        const item = {} as WeekdayMinimumStayRuleItem;
        item.weekday = weekdayInt;
        item.minimumDurationForCheckIn = value;

        dispatch(addWeekdayMinimumStayRestriction(item));
      }
    } else {
      dispatch(removeWeekdayMinimumStayRestriction(weekdayInt));
    }
  };

  const handleUpdateWeekdayMinimumStayRuleItemsData = event => {
    const { checked, name } = event.target;

    const newData = { ...weekdayMinimumStayRuleItemsData };
    newData[name] = checked;
    dispatch(updateWeekdayMinimumStayRuleItemsData(newData));
  };

  const onSubmit = () => {
    dispatch(
      updateSeasonRateWeekdayMinimumStayRulesDataAsync(
        weekdayMinimumStayRuleItemsData,
      ),
    );
    setSubmitted(true);
  };

  return (
    <WeekdayMinimumStayRestrictionsForm
      loadingStatus={weekdayMinimumStayRuleItemsDataStatus}
      handleMinimumStayInputChange={handleWeekdayMinimumStayRuleChange}
      updateWeekdayMinimumStayRuleItemsData={
        handleUpdateWeekdayMinimumStayRuleItemsData
      }
      onSubmit={onSubmit}
      submitted={submitted}
      data={weekdayMinimumStayRuleItemsData}
      hasWriteAccess={hasWriteAccess}
    />
  );
}

export default SeasonRateWeekdayMinimumStayRestrictions;
